import React from "react";
import { Flex, Text, Tooltip } from "@fluentui/react-northstar";

export interface LabeledReportItemProps {
    label: string;
    tooltip?: string;
    content: React.ReactNode;
}

export const LabeledReportItem: React.FC<LabeledReportItemProps> = (props) => {
    return (
        <Flex column={true} fill vAlign="center">
            <Tooltip content={props.tooltip} trigger={
                <div>
                    <Text
                        styles={({ theme: { siteVariables } }) => ({
                            color: siteVariables.colorScheme.default.foreground5,
                            wordBreak: "break-word",
                        })}
                    >
                        {props.label}
                    </Text>
                </div>
            } />
            <div style={{ marginTop: "-2px" }}>{props.content}</div>
        </Flex>
    );
};
